'use es6';

import { ASSOCIATION_UPDATED } from '../constants/updateTypes';
import { getUpdate } from './crmObjectLifecycleUpdateGetters';
import { getUpdateType } from './ticketUpdateMetadataGetters';
export const isTicketAssociationUpdateType = ticket => {
  const update = getUpdate(ticket);
  return getUpdateType(update) === ASSOCIATION_UPDATED;
};